import { makeStyles } from "@mui/styles";
import { SURVEY_COLORS, SURVEY_TYPOGRAPHY, SURVEY_MIXINS } from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styless
export const useMCQWithCommentQuestionStyles = makeStyles(() => ({
  formLabel: {
    paddingBottom: "13px",
  },
  questionText: SURVEY_MIXINS.questionLabel,
  requiredAsterisk: SURVEY_MIXINS.requiredAsterisk,
  optionLabel: SURVEY_MIXINS.optionLabel,
  commentSection: {
    marginTop: "16px",
    marginBottom: "8px",
  },
  commentLabel: {
    fontSize: "13px",
    color: SURVEY_COLORS.TEXT_PRIMARY,
    fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_NORMAL,
  },
  containerError: SURVEY_MIXINS.errorBorder,
}));
